/** "Report a problem" (cowork POST /v1/support/report): the confirmation copy and the page a report names. */
export const REPORT_SENT_TEXT = 'Sent. Your Beatly team will get back to you.';

/** The page as the report names it: the path and query, never the host. */
export function currentPageForReport(): string {
  if (typeof window === 'undefined') return '';
  return `${window.location.pathname}${window.location.search}`;
}
